import React from "react";
const IconHelp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 4.9996H8V2.9996H12V4.9996H11V6.07245C14.3923 6.55767 17 9.47508 17 13.0016V14.0016H16H4H3V13.0016C3 9.47508 5.60771 6.55767 9 6.07245V4.9996ZM5.10002 12.0016H14.9C14.4367 9.71932 12.419 8.00156 10 8.00156C7.58104 8.00156 5.56329 9.71932 5.10002 12.0016ZM18 14.9996V16.9996H2V14.9996H18Z"
      fill="currentColor"
    />
  </svg>
);
export default IconHelp;
